
import lang from 'dojo/_base/lang';
import on from 'dojo/on';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './FileDashboardManager.html?raw';

import FileTile from './FileTile';
import "./FileTile";
import _TabEnabledMixin from '../../moreCore/UI/Tabbing/_TabEnabledMixin';
import { FileDashboard } from "../FileDashboard/FileDashboardTypes";
class FileDashboardManager extends compose(_TabEnabledMixin) {
    templateString: any = template;

    private settings: FileDashboard.DashboardData = null;
    private config: FileDashboard.DashboardConfig = null;

    private tiles: Array<MdsLax<InstanceType<typeof FileTile>>>;

    tilesContainer: HTMLDivElement;
    dashBoardHeading: HTMLHeadingElement;

    private receivedTiles: Array<FileDashboard.TileData>;

    setup(config: FileDashboard.DashboardConfig) {
        if (config) {
            this.config = config;

            if (config.title) {
                this.setHeading(config.title);
            }
        }
    }

    setData(settings: FileDashboard.DashboardData) {
        this.settings = settings;

        this._applyData();

        this.StandbyStop();
    }

    setHeading(text: string) {
        // todo - gehört wahrscheinlich weg. das kann nicht der Manager selber entscheiden

        // text = TranslationHelpers.tryTranslate(text);
        // if (this.isEmbeddedInTab) {
        //     text = "";// keine Überschrift, steht eh in der Tile auch schon drin
        // } else {
            
        // }
        // this.dashBoardHeading.innerHTML = text ?? "";
        // if (!text) this.hideNode(this.dashBoardHeading);
        // else this.hideNode(this.dashBoardHeading, false);
    }

    private _applyData(): void {

        this.UiModder.domConstruct.empty(this.tilesContainer);
        this.tiles = [];

        if (!this.settings) {

            this.dashBoardHeading.innerHTML = "?data?";

            return;
        }

        let settings = this.settings;

        if( settings.title) this.setHeading(settings.title);

        if (!settings.availableTiles || !settings.availableTiles.length) {
            this.tilesContainer.innerHTML = "? no tiles received ?";
        }

        for (let tileData of settings.availableTiles) {
            let tile = new FileTile();
            tile.setData(tileData);

            if (this.isEmbeddedInTab) {
            //    this.UiModder.domClass.add(tile.domNode, "m12")
            //    this.UiModder.domClass.add(tile.domNode, "l6")
                this.UiModder.domClass.add(tile.domNode, "w3-content");
            } else {
                //this.UiModder.domClass.add(tile.domNode, "flex_cell_third");
            }

            tile.placeAt(this.tilesContainer);

            on(tile, "requestFile", lang.hitch(this, this._onRequestNewFile));

            this.tiles.push(tile);
        }

        this.emit("tilesCreated", this.tiles);
    }

    getTiles(): Array<MdsLax<InstanceType<typeof FileTile>>> {
        return this.tiles;
    }

    private _onRequestNewFile(data: FileDashboard.FileRequestData): void {
        if (this.config?.requestFileCallback) {
            this.config.requestFileCallback(data);
        } else {
            this.emit("requestFile", data);
        }
    }

    // Alias
    setFileRequestResponse(data: FileDashboard.FileResponseData): void {
        this.fileRequestResponse(data);
    }
    fileRequestResponse(data: FileDashboard.FileResponseData): void {
        let tile = this.getTileByName(data.fileTileName);

        if (tile) {
            tile.setFileRequestResponse(data);
        }
    }

    private getTileByName(name: string): MdsLax<InstanceType<typeof FileTile>> {
        for (let tile of this.tiles) {
            if (tile.internalName == name) {
                return tile;
            }
        }

        return null;
    }

    _onEmbedding(config: Tabbing.TabContainerPage, name: string): void {
        super._onEmbedding.apply(this, arguments as any);

        this.UiModder.domClass.add(this.tilesContainer, "justify");
    }

    _onClosing(): void {
        super._onClosing.apply(this, arguments as any);
    }

    //-----------------------own methods -------------------------end
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
    }
    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(FileDashboardManager);
